// Curated "What's New" release content. Screenshots are bundled assets captured
// from the running app (see src/assets/updates/). To ship the next release: add
// an entry here and publish an update_logs row with the matching release_key.
import hubShot from '../assets/updates/summer/hub.webp';
import notificationsShot from '../assets/updates/summer/notifications.webp';
import streakShot from '../assets/updates/summer/streak.webp';
import rewardShot from '../assets/updates/summer/reward.webp';

export const RELEASES = {
  'summer-2026': {
    key: 'summer-2026',
    title: 'Summer Update',
    date: '2026-05-31',
    intro: 'A fresh golden-hour look — and a whole new way to keep up with your campaigns.',
    highlights: [
      {
        title: 'A golden-hour makeover',
        body: 'Basecamp and the whole app got a warm sunset redesign, with a tidier command-center layout and a native-style mobile nav.',
        image: hubShot,
      },
      {
        title: 'Never miss a beat',
        body: "Exclamation badges now light up wherever something needs you, and an inbox shows what happened while you were away — including refunds and rewards. Curse someone who never plays? Your item comes right back.",
        image: notificationsShot,
      },
      {
        title: 'Streak bonuses',
        body: 'Keep your daily streak alive to claim coin bonuses at 3, 5 and 7 days. Tap the streak on your basecamp to collect.',
        image: streakShot,
      },
      {
        title: 'A royal reward picker',
        body: 'Win the week and the reward picker got a full themed makeover — and the players you choose now get notified of their Oracle Whispers.',
        image: rewardShot,
      },
    ],
  },
};

export function getRelease(key) {
  return (key && RELEASES[key]) || null;
}
